const ScheduleOption = {
  NOT_SELECTED: 'NOT_SELECTED',
  SEND_NOW: 'SEND_NOW',
  SET_DATE_TIME: 'SET_DATE_TIME',
};

export default ScheduleOption;
